import $ from 'jquery';
import prestashop from 'prestashop';

$(document).ready(function () {
  createProductSpin();

  $('.js-product-images-nav').slick({
    rows: 0,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    focusOnSelect: true,
    asNavFor: '.js-product-images-main',
  });

  $('.js-product-images-main').slick({
    rows: 0,
    fade: true,
    arrows: false,
    slidesToShow: 1,
    infinite: true,
    asNavFor: '.js-product-images-nav',
  });

  $('.js-sticky-addtocart').on('click', function () {
    $('.product-add-to-cart [data-button-action="add-to-cart"]').trigger('click');
  });

  $('.js-sticky-quantity-wanted').on('change keyup', function () {
    $('#quantity-wanted').val($(this).val());
  });

  prestashop.on('updatedProduct', function (event) {
    if (event && event.product_minimal_quantity) {
      const minimalProductQuantity = parseInt(event.product_minimal_quantity, 10);
      const quantityInputSelector = '.js-quantity-wanted';
      let quantityInput = $(quantityInputSelector);

      quantityInput.trigger('touchspin.updatesettings', {min: minimalProductQuantity});
    }

    $($('.tabs .nav-link.active').attr('href')).addClass('active').removeClass('fade');
  });

  $(document).on('click', '.js-zoom-modal-link', function (e) {
    e.preventDefault();

    $('#zoom-modal').modal('show');
  });

  $('#zoom-modal').on('shown.bs.modal', function () {

    $('.js-product-images-modal').slick({
      rows: 0,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
    });

    $('.js-product-images-modal').slick('slickGoTo', $('.js-product-images-main').slick('slickCurrentSlide'), true);
  });

  $('#zoom-modal').on('hidden.bs.modal', function () {
    $('.js-product-images-modal.slick-initialized').slick('unslick');
  });

  function createProductSpin() {
    const $quantityInput = $('.js-quantity-wanted');

    $quantityInput.TouchSpin({
      buttondown_class: 'btn btn-link js-touchspin text-inherit',
      buttonup_class: 'btn btn-link js-touchspin text-inherit',
      min: parseInt($quantityInput.attr('min'), 10),
      max: Infinity
    });

    $quantityInput.closest('.input-wrapper').addClass('touchspin-loaded');

    $('body').on('change keyup', '.js-quantity-wanted', (e) => {
      $(e.currentTarget).trigger('touchspin.stopspin');

      prestashop.emit('updateProduct', {
        eventType: 'updatedProductQuantity',
        event: e
      });
    });

    $('body').on('change keyup', '.js-pack-quantity-wanted', (e) => {
      $(e.currentTarget).trigger('touchspin.stopspin');
      if(e.currentTarget.value > e.currentTarget.dataset.qtyMax) {
        e.currentTarget.value = e.currentTarget.dataset.qtyMax;
      }
    });
  }
});



// WEBPACK FOOTER //
// ./themes/maisondubillard/_dev/js/product.js